import * as React from 'react'
import { Dialog, DialogContent, DialogActions, DialogContentText, DialogTitle } from '@mui/material'
import { Button } from '../Button'
import { ConfirmDialogProps } from './ConfirmDialogProps'

export const ConfirmDialog = ({
  onConfirm,
  onCancel,
  onClose,
  confirmLabel,
  cancelLabel,
  dialogMessage,
  dialogTitle,
  extraButtons: _extraButtons,
  ...rest
}: ConfirmDialogProps) => {
  return (
    <Dialog fullWidth maxWidth='xs' onClose={onClose} {...rest}>
      <DialogTitle id='alert-dialog-title'>{dialogTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>{dialogMessage}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {cancelLabel && (
          <Button onClick={onCancel} variant='text'>
            {cancelLabel}
          </Button>
        )}
        <Button onClick={onConfirm} autoFocus>
          {confirmLabel ? confirmLabel : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
